module.exports = __webpack_public_path__ + "static/media/je.12bf2a5f.svg";